import { createAction } from '@reduxjs/toolkit';
export const FETCH_CALL_HISTORY = 'FETCH_CALL_HISTORY';
export const fetchCallHistoryAction = createAction(FETCH_CALL_HISTORY);
